import { Input } from '@insify/design-system/components';
import IBAN from 'iban';
import { forwardRef, useEffect, useState } from 'react';

import type { InputProps } from '@insify/design-system/components';
import type React from 'react';

export const noSeparatorsRegex = /^((?!.*[.,-].*).)*$/;

export const InputIban = forwardRef(
  (
    { className = '', error, defaultValue, name, placeholder, label, ...props }: InputProps,
    ref: React.ForwardedRef<HTMLInputElement>,
  ): JSX.Element => {
    const [ibanValid, setIbanValid] = useState(false);

    useEffect(() => void setIbanValid(isIbanValid(defaultValue as string)), [defaultValue]);

    const isIbanValid = (iban: string): boolean => IBAN.isValid(iban) && noSeparatorsRegex.test(iban);

    const handleIbanChange = async (event: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
      const input = event.target;
      setIbanValid(isIbanValid(input.value));

      const start = input.selectionStart;
      const end = input.selectionEnd;
      event.target.value = input.value.toUpperCase();
      input.setSelectionRange(start, end);

      props.onChange?.(event);
    };

    return (
      <Input
        {...props}
        id={props.id}
        data-testid={ibanValid ? 'valid-iban' : 'invalid-iban'}
        label={label}
        className={className}
        name={name}
        ref={ref}
        error={error}
        placeholder={placeholder}
        defaultValue={defaultValue}
        onInput={handleIbanChange}
        showSuccess={ibanValid}
      />
    );
  },
);
